import type { Quote } from '@/types'

/**
 * The line under the speaker's name, composed from the attribution as the page
 * wrote it: "’23 · Nursing · RN, cardiac ICU". Each part is kept raw (APP-57),
 * so this joins them rather than parsing any.
 */
export function speakerLine(q: Pick<Quote, 'classYear' | 'majors' | 'currentPosition'>): string {
  return [q.classYear, q.majors, q.currentPosition].filter(Boolean).join(' · ')
}
